import { useEffect, useState, useCallback, useRef } from "react";
import { AbandonedCartService } from "../services/abandoned-cart.service";

interface AbandonedCartState {
  enabled: boolean;
  loading: boolean;
  error: string | null;
  toggling: boolean;
}

interface AbandonedCartActions {
  toggle: (enabled: boolean) => Promise<void>;
}

export function useAbandonedCart(): AbandonedCartState & AbandonedCartActions {
  const [state, setState] = useState<AbandonedCartState>({
    enabled: false,
    loading: true,
    error: null,
    toggling: false,
  });

  const hasLoadedRef = useRef(false);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setState((s) => ({ ...s, loading: !hasLoadedRef.current, error: null }));
      try {
        const data = await AbandonedCartService.getConfig();
        if (!cancelled) {
          hasLoadedRef.current = true;
          setState((s) => ({ ...s, enabled: data.enabled, loading: false }));
        }
      } catch (err) {
        if (!cancelled)
          setState((s) => ({
            ...s,
            loading: false,
            error: err instanceof Error ? err.message : "Error desconocido",
          }));
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const toggle = useCallback(async (enabled: boolean) => {
    setState((s) => ({ ...s, toggling: true, error: null }));
    try {
      const data = await AbandonedCartService.updateConfig(enabled);
      setState((s) => ({ ...s, toggling: false, enabled: data.enabled }));
    } catch (err) {
      setState((s) => ({
        ...s,
        toggling: false,
        error: err instanceof Error ? err.message : "Error al actualizar",
      }));
      throw err;
    }
  }, []);

  return { ...state, toggle };
}
